'use client';

import type { SearchResultDocument } from '@/lib/addsearch/types';
import { ResultItem } from '../ResultItem/ResultItem';
import { useGlobalLabels } from '@/context/GlobalLabelContext';
import { searchResultsVariants } from './SearchResults.styles';

interface SearchResultsProps {
  hits: SearchResultDocument[];
  query: string;
  isResultsPage?: boolean;
  onResultClick?: () => void;
}

export const SearchResults = ({
  hits,
  query,
  onResultClick,
  isResultsPage,
}: SearchResultsProps) => {
  const {
    globalLabels: { search_labels },
  } = useGlobalLabels();

  const { noResults, list } = searchResultsVariants();

  if (query && hits.length === 0) {
    return (
      <p role="status" className={noResults()}>
        {search_labels?.no_results} <strong>&ldquo;{query}&rdquo;</strong>.
      </p>
    );
  }

  if (hits.length === 0) {
    return null;
  }

  return (
    <ol role="list" aria-label="Search result items" className={list()}>
      {hits.map((hit) => (
        <li key={hit.id}>
          <ResultItem
            hit={hit}
            query={query}
            onClick={onResultClick}
            isResultsPageItem={isResultsPage}
          />
        </li>
      ))}
    </ol>
  );
};
